import { BrandProvider } from '@hbo/ui-servicing-react-components';
import Routes from 'Routes';
import { HelmetProvider } from 'react-helmet-async';

interface ProvidersProps {
  children: React.ReactNode | React.ReactNode[];
}

const Providers: React.FC<ProvidersProps> = () => {
  return (
    <HelmetProvider>
      <BrandProvider brand={window.obm.brand}>
        <Routes />
      </BrandProvider>
    </HelmetProvider>
  );
};

export default Providers;
